import { Image } from "@/components/shared/image";

type LeftArrowProps = {
  onClick: () => void;
  canScrollNext: boolean;
  canScrollPrev: boolean;
  isRtl: boolean;
};

export const LeftArrow = ({ onClick, canScrollNext, canScrollPrev, isRtl }: LeftArrowProps) => {
  return (
    <div
      onClick={onClick}
      className={`absolute top-1/2 h-8 w-8 -translate-y-1/2 sm:h-12 sm:w-12 md:h-16 md:w-16 rtl:left-0 ${
        !(isRtl ? canScrollNext : canScrollPrev)
          ? "cursor-not-allowed opacity-50"
          : "cursor-pointer"
      } `}
    >
      <Image src="/assets/svgs/left-arrow.svg" width={58} height={58} alt="left arrow" />
    </div>
  );
};

type RightArrowProps = {
  onClick: () => void;
  canScrollNext: boolean;
  canScrollPrev: boolean;
  isRtl: boolean;
};

export const RightArrow = ({ onClick, canScrollNext, canScrollPrev, isRtl }: RightArrowProps) => {
  return (
    <div
      onClick={onClick}
      className={`absolute right-0 top-1/2 h-8 w-8 -translate-y-1/2 sm:h-12 sm:w-12 md:h-16 md:w-16 ${
        !(isRtl ? canScrollPrev : canScrollNext)
          ? "cursor-not-allowed opacity-50"
          : "cursor-pointer"
      } `}
    >
      <Image src="/assets/svgs/right-arrow.svg" width={58} height={58} alt="right arrow" />
    </div>
  );
};
